import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChevronUp = () => {
  return (
    <g>
      <path d="m14.04 11.77a.7467.7467 0 0 1 -.53-.22l-5.51-5.5095-5.51 5.51a.75.75 0 1 1 -1.06-1.0605l6.04-6.04a.75.75 0 0 1 .53-.22.7494.7494 0 0 1 .53.22l6.04 6.04a.75.75 0 0 1 -.53 1.28z" />
    </g>
  );
};

export default withIcon(IconChevronUp);
